/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const TruckCabRegular = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 92 72" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M53.3 58.1c0 .5 0 1-.1 1.5h38.3V50H51.4c1.2 2.5 1.9 5.3 1.9 8.1zM1.8 50c-.7.2-1.3.9-1.3 1.7v6.2c0 .9.8 1.7 1.7 1.7h15.9c0-.5-.1-1-.1-1.5 0-2.8.7-5.6 2-8.1H1.8zM65.9.6L44.4 19.7S5 22.1 5 36v.8h9.6c.8 0 1.4.7 1.4 1.4v1.3c0 .8-.7 1.4-1.4 1.4H5v5.9h17.1c6.2-7.5 17.2-8.6 24.8-2.4.9.7 1.7 1.5 2.4 2.4h42.2V.6H65.9zm1.9 5.3h17.5v15.4H50.9L67.8 5.9zm17.5 23.2H74.5V27h10.8v2.1z" /><circle cx="35.9" cy="58" r="13.7" /></g>
      </g>
    </svg>
  </span>
);

TruckCabRegular.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

TruckCabRegular.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default TruckCabRegular;
